import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { Comment } from 'types'

export const PreviousItemButton = observer(() => {
  const docStore = useDocStore()
  const { collabItemsStore, orderedFilteredCollabItems } = docStore

  const selectedItemIndex = orderedFilteredCollabItems.findIndex(
    (item) => (item.item as Comment).id === collabItemsStore.selectedId,
  )

  const previousIndex = selectedItemIndex - 1
  const previousComment = orderedFilteredCollabItems[previousIndex]?.item as Comment

  const selectPrevious = () => {
    if (!previousComment) return

    collabItemsStore.selectById(previousComment.id)
    if (previousComment.uuid) collabItemsStore.select(previousComment.uuid)
    const comment = docStore.rootStore.comments.get(previousComment.id)

    if (!comment) return
    docStore.rootStore.comments.select(comment.id)
  }

  return <Button isDisabled={!previousComment} aria-label="Previous Item" icon={ChevronLeft} onPress={selectPrevious} />
})
